import { SessionInfoResponse } from '@src/api.types';
import { TMemberInfo } from '@repo/utils';

export class sessionService {
  static formatSessionData(data: SessionInfoResponse) {
    if (data.data) {
      try {
        if (data.data['phone']) {
          //format phone
          data.data.phone = data.data['phone']
            .replace(/\D+/g, '')
            .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        }
        data.data.first_name = this.formatName(data.data['first_name']);
        data.data.last_name = this.formatName(data.data['last_name']);
        return {
          ...data.data,
          addrZipCode: data.data.zipCode,
          medSup: data.data.medSup ?? false,
        } as TMemberInfo;
      } catch (err) {}
    }
  }

  static formatName(part: string) {
    if (!part) {
      return '';
    }
    return part[0].toUpperCase() + part.substring(1).toLowerCase();
  }

  isoDate(dob: string) {
    if (typeof dob === 'string') {
      const a = dob.split('-') ?? dob.split('/');
      if (a.length === 1) {
        const tmp = a[0].split('/').join('-').split('-'); // replaceAll compiler workaround
        return `${tmp[2]}-${tmp[0]}-${tmp[1]}`;
      }

      return `${a[0]}-${a[1]}-${a[2]}`;
    }

    return '';
  }
}
